import { Routes } from "@angular/router";
import { LayoutComponent } from "../layout/layout.component";

export const routes: Routes = [
  {
    path: "",
    component: LayoutComponent,
    children: [
      // Match the homepage before the empty-prefix catalog module. An empty
      // catalog branch can otherwise finish navigation without a page component.
      {
        path: "",
        pathMatch: "full",
        loadChildren: () => import("./home/home.module").then(m => m.HomeModule),
      },
      { path: "", loadChildren: () => import("./commerce-products/commerce-products.module").then(m => m.CommerceProductsModule) },
      { path: "shop", loadChildren: () => import("./shop/shop.module").then(m => m.ShopModule) },
      {
        path: "",
        loadChildren: () => import("./auth/auth.module").then(m => m.AuthModule),
      },
      {
        path: "earnings-calculator",
        loadChildren: () =>
          import("./calculator/backup-machine/backup-machine.module").then(m => m.BackupMachineModule),
      },
      {
        path: "machines",
        loadChildren: () => import("./calculator/machines/machines.module").then(m => m.MachinesModule),
      },
      {
        path: "hauling",
        loadChildren: () => import("./calculator/hauling/hauling.module").then(m => m.HaulingModule),
      },
      {
        path: "service",
        loadChildren: () => import("./calculator/service-provider/service.module").then(m => m.ServiceProviderModule),
      },
      {
        path: "checkout",
        loadChildren: () => import("./checkout/checkout.module").then(m => m.CheckoutModule),
      },
      {
        path: "cart",
        loadChildren: () => import("./cart/cart.module").then(m => m.CartModule),
      },
      {
        path: "s",
        loadChildren: () => import("./share-redirect/share-redirect.module").then(m => m.ShareRedirectModule),
      },
      {
        path: "help",
        loadChildren: () => import("./help/help.module").then(m => m.HelpModule),
      },
      {
        path: "gps",
        loadChildren: () => import("./gps/gps.module").then(m => m.GpsModule),
      },
      {
        path: "lp",
        loadChildren: () => import("./landing-page/landing-page.module").then(m => m.LandingPageModule),
      },
      {
        path: "about",
        loadChildren: () => import("./about/about.module").then(m => m.AboutModule),
      },
      {
        path: "contact",
        loadChildren: () => import("./contact/contact.module").then(m => m.ContactModule),
      },
      {
        path: "how-it-works",
        redirectTo: "/lp/how-it-works",
        pathMatch: "full",
      },
      {
        path: "search",
        redirectTo: "/equipment-rentals",
        pathMatch: "full",
      },
      {
        path: "equipment-rental",
        loadChildren: () => import("./machine-details/machine-details.module").then(m => m.MachineDetailsModule),
      },
      {
        path: "equipment-for-sale",
        loadChildren: () => import("./machine-details/machine-details.module").then(m => m.MachineDetailsModule),
      },
      {
        path: "equipment",
        loadChildren: () => import("./machine-details/machine-details.module").then(m => m.MachineDetailsModule),
      },
      {
        path: "",
        loadChildren: () => import("./search-results/search-results.module").then(m => m.SearchResultsModule),
      },
      {
        path: "activity",
        loadChildren: () => import("./activity/activity.module").then(m => m.ActivityModule),
      },
      {
        path: "blog",
        loadChildren: () => import("./blog/blog.module").then(m => m.BlogModule),
      },
      {
        path: "machine-locations",
        loadChildren: () => import("./machine-locations/machine-locations.module").then(m => m.MachineLocationsModule),
      },
      {
        path: "",
        loadChildren: () => import("./manage/manage.module").then(m => m.ManageModule),
      },
    ],
  },

  // Not lazy-loaded routes
  // { path: 'register', component: RegisterComponent },
  // { path: 'recover', component: RecoverComponent },
  // { path: 'lock', component: LockComponent },
  // { path: 'maintenance', component: MaintenanceComponent },
  // { path: '404', component: Error404Component },
  // { path: '500', component: Error500Component },

  // Not found
  { path: "**", redirectTo: "" },
];
